import React, { Fragment, useState } from "react";
import { useCustomerBankDetails } from "../../../../custom-hooks/useCustomerBankDetails";
import { formatMoney } from "../../../../helpers/formatter";
import Loader from "../../../../NewComponents/Loader/Loader.component";
import Paginator from "../../../Pagination/Pagination.component";

const CustomerBankStatementData = ({ customerId }: any) => {
  const [count, setCount] = useState(null);

  const [search, setSearch] = useState<{
    PageSize: number;
    Page: number;
    CustomerId: number;
    DateFrom: any;
    DateTo: any;
  }>({
    PageSize: 20,
    Page: 1,
    CustomerId: customerId,
    DateFrom: null,
    DateTo: null,
  });
  const [presearch, setPresearch] = useState({
    Page: 1,
    PageSize: 20,
    CustomerId: customerId,
    // DateFrom: "2022-01-09T00:00:00.000",
    // DateTo: "2024-10-05T00:00:00.000",
  });
  const {
    data: bankStatementDetailsData,
    status,
    error,
  } = useCustomerBankDetails(presearch);
  if (bankStatementDetailsData) {
    if (count === null) {
      setCount(bankStatementDetailsData?.totalCount);
    }
  }

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setSearch({ ...search, [name]: value, Page: search.Page, PageSize: 20 });
  };
  let RenderedComponent = null;
  if (!bankStatementDetailsData && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Customer Bank
            Statement Data
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    //@ts-ignore
    RenderedComponent = <Loader centered="true" text="Loading Repayment..." />;
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              Bank statement, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (bankStatementDetailsData &&
        bankStatementDetailsData?.transactions &&
        bankStatementDetailsData?.transactions.length === 0) ||
      (bankStatementDetailsData && !bankStatementDetailsData?.transactions)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no requests.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>S/N</th>
                  <th>Transaction ID</th>
                  <th>Transaction Type</th>
                  <th>Transaction Date</th>
                  <th>Bank Name</th>
                  <th>Currency</th>
                  <th>Amount</th>
                  <th>Balance</th>
                  <th>Narration</th>
                </tr>
              </thead>
              <tbody>
                {bankStatementDetailsData?.transactions
                  // ?.slice(
                  //   (pageNumber - 1) * size,
                  //   size * (pageNumber - 1) + size
                  // )
                  .map((data: any, id: number) => {
                    const {
                      transactionId,
                      transactionType,
                      //   type,
                      date,
                      narration,
                      amount,
                      balance,
                      currency,
                    } = data;
                    return (
                      <tr key={id}>
                        <td>{id + 1}</td>
                        <td>{transactionId}</td>
                        <td>{transactionType}</td>
                        <td>{date?.substring(0, 10)}</td>
                        <td>{bankStatementDetailsData?.bankName}</td>
                        <td>{currency}</td>
                        <td>{formatMoney(amount)}</td>
                        <td>{formatMoney(balance)}</td>
                        <td>{narration}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  return (
    <Fragment>
      <div className="dataTables_wrapper">
        <div
          id="activeEcosystem"
          className="Disbursement table-view animated speed-1x fadeInRight"
        >
          <form className="d-flex flex-row flex-wrap">
            <div className="form-group mr-3 mt-2">
              <div className="input-group ">
                <label className="mr-2">From </label>
                <input
                  type="date"
                  name="DateFrom"
                  className="form-control"
                  value={search.DateFrom}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>
            <div className="form-group mt-2 mr-3">
              <div className="input-group">
                <label className="mr-2">To </label>
                <input
                  type="date"
                  className="form-control"
                  name="DateTo"
                  value={search.DateTo}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="btn advancly-btn btn-md"
                value="submit"
                disabled={status === "loading" || !bankStatementDetailsData}
                onClick={() => setPresearch(search)}
              >
                Search
              </button>
            </div>
          </form>

          {/*Datatable || Loader || Error Message*/}
          {RenderedComponent}
          <Paginator
            size={presearch.PageSize}
            page={presearch.Page}
            count={count}
            changeCurrentPage={(Page: any) => setPresearch({ ...search, Page })}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default CustomerBankStatementData;
